import '@splidejs/splide/css';
import { Splide, Options } from '@splidejs/splide';
import { AppModule } from '../../lib/app-module';

export interface SlideConfig {
    target: string;
    options?: Options
}

interface SlideExport {
    load: (config: SlideConfig, ...synched: SlideConfig[]) => void
}

export class Slide extends AppModule<SlideConfig | undefined, SlideExport> {
    protected init(): void {
        this._export = {
            load: (config: SlideConfig, ...synched: SlideConfig[]) => this.loadSlides(config, ...synched)
        };
        if (this.config) {
            this.loadSlides(this.config);
        }
    }

    private loadSlides(config: SlideConfig, ...synched: SlideConfig[]): void {
        const main = new Splide(config.target, config.options);
        const others = synched.map((otherConfig): Splide => {
            const other = new Splide(otherConfig.target, otherConfig.options);
            main.sync(other);
            return other;
        });
        [main, ...others].forEach(splideInstance => splideInstance.mount());
    }
}